import { LocalisationService } from './services/localisation.service';
import { OptimaxService } from '../mailing/shared/services/optimax.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { ModuleHeaderComponent } from './components/module-header/module-header.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { MatTableModule, MatFormFieldModule, MatSortModule, MatPaginatorModule, MatPaginatorIntl, MatMenuModule, MatBadgeModule, MatNativeDateModule, MatDatepickerModule } from '@angular/material';
import { MatInputModule, MatSelectModule, MatCheckboxModule, MatTooltipModule, MatAutocompleteModule, MatSnackBarModule } from '@angular/material';
import { MatSliderModule, MatListModule, MatTabsModule, MatProgressSpinnerModule, MatRadioModule, MatButtonModule } from '@angular/material';
import { MatProgressBarModule, MatChipsModule, MatStepperModule } from '@angular/material';
import { MatCardModule, MatDividerModule, MatExpansionModule, MatIconModule, MatDialogModule, PageEvent } from '@angular/material';
import { MatPaginatorIntlFr } from './classes/matPaginatorIntlFr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapitalizePipe } from './pipes/capitalize';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SelectSearchComponent } from './components/select-search/select-search.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from './pipes/localizedDate';
import { SortablejsModule } from 'angular-sortablejs';
import { SanitizeHtmlPipe } from './pipes/sanitize';
import { IframeAutoHeightDirective } from './directives/iframe-auto-height';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { EmailToLinkPipe } from './pipes/emailToLink';
import { RouterModule } from '@angular/router';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { MenuDetailComponent } from './components/menu-detail/menu-detail.component';
import { DomChangeDirective } from './directives/dom-change';
import { IdentiteQuickNewComponent } from './components/identite-quick-new/identite-quick-new.component';
import { AdminListZoneComponent } from './components/admin-list-zone/admin-list-zone.component';
import { AdminListEtatIdentiteComponent } from './components/admin-list-etat-identite/admin-list-etat-identite.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { AdminListVilleComponent } from './components/admin-list-ville/admin-list-ville.component';
import { AdminListContactTypeComponent } from './components/admin-list-contact-type/admin-list-contact-type.component';
import { ContactTypeService } from '../identite/shared/services/contact-type.service';
import {AdminListTypeConventionComponent} from "./components/admin-list-type-convention/admin-list-type-convention.component";
import { FicheHeadingComponent } from './components/fiche-heading/fiche-heading.component';
import { FicheFootingComponent } from './components/fiche-footing/fiche-footing.component';
import { DeleteValidationDialogComponent } from './components/delete-validation-dialog/delete-validation-dialog.component';
import { BureauxSelectComponent } from './components/bureaux-select/bureaux-select.component';
import {SearchBatimentComponent} from './components/search-batiment/search-batiment.component';
import {InfrastructureService} from '../infrastructure/shared/services/infrastructure.service';
import {FormatNumberWithSpace} from './pipes/formatNumberWithSpace';
import {ForcePositiveNumber} from './pipes/forcePositiveNumber';
import {FormatDateFromString} from './pipes/formatDateFromString';
import {FallbackTableValue} from './pipes/fallback-table-value';
import {SearchRoleByNameComponent} from './components/search-role-by-name/search-role-by-name.component';
import { SearchRoleOrCreateComponent } from './components/search-role-or-create/search-role-or-create.component';
import { OptimaxLoginComponent } from './components/optimax-login/optimax-login.component';
import { OptimaxGlobaleUserService } from './services/optimax-globale-user.service';
import {NgForInDirective} from './directives/ngforin.directive';
import { OptimaxSelectContextComponent } from './components/optimax-select-context/optimax-select-context.component';
import {AdminListModeContactComponent} from './components/admin-list-mode-contact/admin-list-mode-contact.component';
import {AdminListTypeRdvComponent} from './components/admin-list-type-rdv/admin-list-type-rdv.component';
import {DynamicInputComponent} from './components/dynamic-input/dynamic-input.component';
import {AdminAgendaComponent} from './components/admin-agenda/admin-agenda.component';
import {Z16proOngletPersonnaliseComponent} from './components/z16pro-onglet-personnalise/z16pro-onglet-personnalise.component';
import {SelectComponent} from './components/dynamic-input/select/select.component';
import {InputComponent} from './components/dynamic-input/input/input.component';
import {AgendaService} from '../agenda/shared/services/agenda.service';
import {EchangeDonneesComponent} from './components/echange-donnees/echange-donnees.component';
import {EchangeDonneesService} from './services/echange-donnees.service';
import {CheckboxComponent} from './components/dynamic-input/checkbox/checkbox.component';
import {AdminListProvenanceComponent} from './components/admin-list-provenance/admin-list-provenance.component';
import { CommentairesComponent } from './components/commentaires/commentaires.component';
import {CommentaireService} from './services/commentaire.service';
import { CommentaireFormComponent } from './components/commentaires/commentaire-form/commentaire-form.component';
import {FormattedNumberDirective} from './directives/formatted-number.directive';
import { EtatTacheService } from '../tache/shared/services/etatTache.service';
import { TypeTacheService } from '../tache/shared/services/typeTache.service';
import { AdminListTypeEtatTacheComponent } from './components/admin-list-type-etat-tache/admin-list-type-etat-tache.component';
import { AdminListTypeCategorieTacheComponent } from './components/admin-list-type-categorie-tache/admin-list-type-categorie-tache.component';
import { SelectIndiceComponent } from './components/select-indice/select-indice.component';
import {IbanFormatPipe} from "./pipes/ibanFormat";
import { SelectRoleComponent } from './components/select-role/select-role.component';
import {SessionService} from "./services/session.service";
import { PaginationComponent } from './components/pagination/pagination.component';
import { FusionValidationDialogComponent } from './components/fusion-validation-dialog/fusion-validation-dialog.component';
import { SelectCouleurComponent } from './components/dynamic-input/select-couleur/select-couleur.component';
import { LegendInputComponent } from './components/dynamic-input/legend-input/legend-input.component';
import { TableComponent } from './components/dynamic-table/table/table.component';
import { DynamicTableComponent } from './components/dynamic-table/dynamic-table.component';
import { DocumentInputComponent } from './components/dynamic-input/document-input/document-input.component';
import { DocumentsTableInputComponent } from './components/dynamic-input/documents-table-input/documents-table-input.component';
import { SpacerComponent } from './components/dynamic-input/spacer/spacer.component';
import { SelectCommerciauxComponent } from './components/select-commerciaux/select-commerciaux.component';
import { AdminListUniteComponent } from './components/admin-list-unite/admin-list-unite.component';
import { AdminListRoleComponent } from './components/admin-list-role/admin-list-role.component';
import { AdminArticleComponent } from './components/admin-article/admin-article.component';
import { AdminArticleDetailComponent } from './components/admin-article/admin-article-detail/admin-article-detail.component';
import { AdminListArticleCategorieComponent } from './components/admin-list-article-categorie/admin-list-article-categorie.component';
import { AdminListArticleTypeUniteComponent } from './components/admin-list-article-type-unite/admin-list-article-type-unite.component';
import { SelectArticleComponent } from './components/select-article/select-article.component';
import { ArchiveValidationDialogComponent } from './components/archive-validation-dialog/archive-validation-dialog.component';
import { DashIfEmptyPipe } from './pipes/dashIfEmpty';
import { CopyValidationDialogComponent } from './components/copy-validation-dialog/copy-validation-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatFormFieldModule,
        ColorPickerModule,
        MatInputModule,
        MatButtonModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatSortModule,
        MatPaginatorModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatSnackBarModule,
        MatSliderModule,
        MatDividerModule,
        MatCardModule,
        MatBadgeModule,
        MatExpansionModule,
        MatIconModule,
        MatListModule,
        MatDialogModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        FlexLayoutModule,
        MatProgressBarModule,
        MatChipsModule,
        MatStepperModule,
        TranslateModule,
        InternationalPhoneNumberModule,
        SortablejsModule.forRoot({animation: 150})
    ],
    declarations: [
        BackButtonComponent,
        ModuleHeaderComponent,
        SnackbarComponent,
        FormatNumberWithSpace,
        ForcePositiveNumber,
        FallbackTableValue,
        CapitalizePipe,
        LocalizedDatePipe,
        EmailToLinkPipe,
        SanitizeHtmlPipe,
        IbanFormatPipe,
        FormatDateFromString,
        SelectSearchComponent,
        IframeAutoHeightDirective,
        DomChangeDirective,
        PaginatorComponent,
        IdentiteQuickNewComponent,
        MenuDetailComponent,
        AdminListZoneComponent,
        AdminListEtatIdentiteComponent,
        AdminListVilleComponent,
        AdminListContactTypeComponent,
        AdminListTypeConventionComponent,
        FicheHeadingComponent,
        FicheFootingComponent,
        CopyValidationDialogComponent,
        DeleteValidationDialogComponent,
        FusionValidationDialogComponent,
        BureauxSelectComponent,
        SearchBatimentComponent,
        SearchRoleByNameComponent,
        SearchRoleOrCreateComponent,
        OptimaxLoginComponent,
        NgForInDirective,
        FormattedNumberDirective,
        OptimaxSelectContextComponent,
        AdminAgendaComponent,
        DynamicInputComponent,
        InputComponent,
        SelectComponent,
        Z16proOngletPersonnaliseComponent,
        EchangeDonneesComponent,
        AdminListModeContactComponent,
        AdminListTypeRdvComponent,
        CheckboxComponent,
        AdminListProvenanceComponent,
        CommentairesComponent,
        AdminListTypeEtatTacheComponent,
        AdminListUniteComponent,
        AdminListTypeCategorieTacheComponent,
        CommentaireFormComponent,
        SelectIndiceComponent,
        SelectRoleComponent,
        PaginationComponent,
        TableComponent,
        DynamicTableComponent,
        SelectCouleurComponent,
        LegendInputComponent,
        DocumentInputComponent,
        DocumentsTableInputComponent,
        SpacerComponent,
        SelectCommerciauxComponent,
        AdminListRoleComponent,
        AdminArticleComponent,
        AdminArticleDetailComponent,
        AdminListArticleCategorieComponent,
        AdminListArticleTypeUniteComponent,
        SelectArticleComponent,
        ArchiveValidationDialogComponent,
        DashIfEmptyPipe,
        CopyValidationDialogComponent
    ],
    exports: [
        BackButtonComponent,
        FormsModule,
        ReactiveFormsModule,
        ModuleHeaderComponent,
        SnackbarComponent,
        ColorPickerModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatSortModule,
        MatPaginatorModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatSnackBarModule,
        MatSliderModule,
        MatDividerModule,
        MatCardModule,
        MatBadgeModule,
        MatListModule,
        MatIconModule,
        MatExpansionModule,
        MatDialogModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        FormatNumberWithSpace,
        ForcePositiveNumber,
        FallbackTableValue,
        CapitalizePipe,
        LocalizedDatePipe,
        EmailToLinkPipe,
        SanitizeHtmlPipe,
        IbanFormatPipe,
        FormatDateFromString,
        SelectSearchComponent,
        FlexLayoutModule,
        MatProgressBarModule,
        MatChipsModule,
        MatStepperModule,
        TranslateModule,
        InternationalPhoneNumberModule,
        SortablejsModule,
        PaginatorComponent,
        IframeAutoHeightDirective,
        DomChangeDirective,
        IdentiteQuickNewComponent,
        AdminListZoneComponent,
        AdminListEtatIdentiteComponent,
        AdminListVilleComponent,
        AdminListContactTypeComponent,
        AdminListTypeConventionComponent,
        MenuDetailComponent,
        FicheHeadingComponent,
        FicheFootingComponent,
        BureauxSelectComponent,
        SearchBatimentComponent,
        SearchRoleByNameComponent,
        SearchRoleOrCreateComponent,
        OptimaxLoginComponent,
        NgForInDirective,
        FormattedNumberDirective,
        OptimaxSelectContextComponent,
        AdminListModeContactComponent,
        AdminListVilleComponent,
        AdminListTypeRdvComponent,
        AdminListContactTypeComponent,
        MenuDetailComponent,
        AdminAgendaComponent,
        DynamicInputComponent,
        InputComponent,
        SelectComponent,
        Z16proOngletPersonnaliseComponent,
        EchangeDonneesComponent,
        CheckboxComponent,
        AdminListProvenanceComponent,
        AdminListTypeEtatTacheComponent,
        AdminListUniteComponent,
        AdminListTypeCategorieTacheComponent,
        CommentairesComponent,
        SelectIndiceComponent,
        SelectRoleComponent,
        PaginationComponent,
        SelectCouleurComponent,
        LegendInputComponent,
        DocumentInputComponent,
        SelectCommerciauxComponent,
        AdminListRoleComponent,
        AdminArticleComponent,
        SelectArticleComponent,
        AdminListArticleCategorieComponent,
        AdminListArticleTypeUniteComponent,
        DashIfEmptyPipe
    ],
    providers: [
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlFr },
        OptimaxService,
        LocalisationService,
        InfrastructureService,
        OptimaxGlobaleUserService,
        NgForInDirective,
        FormattedNumberDirective,
        AgendaService,
        ContactTypeService,
        EchangeDonneesService,
        EtatTacheService,
        TypeTacheService,
        CommentaireService,
        SessionService,
        FormatNumberWithSpace
    ],
    entryComponents: [
        CopyValidationDialogComponent,
        DeleteValidationDialogComponent,
        FusionValidationDialogComponent,
        ArchiveValidationDialogComponent
    ]
})
export class SharedModule { }

